import "./action-button.scss";
import Down from '../../../assets/images/icons/chevron-down.png';


type ActionButtonProps = {
    label: string,
    stylish?: string,
    onClick: () => void,
    disabled?: boolean,
    minimal?: string
}

export const ActionButton: React.FC<ActionButtonProps> = (props) => {

    return (
        <button className={`button ${props.stylish} ${props.minimal}`} 
            onClick={props.onClick} 
            disabled={props.disabled}>
            <div className="img-wrapper">
                <img src={Down} alt="" />
            </div>
            {props.label}
        </button>
    )
}